var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _LfoModulatorBoxAdapter_instances, _a, _LfoModulatorBoxAdapter_wrapParameters;
import { StringMapping, ValueMapping } from "@opendaw/lib-std";
import { PPQN } from "@opendaw/lib-dsp";
import { ModulatorBoxAdapter } from "./ModulatorBoxAdapter";
export var LfoShape;
(function (LfoShape) {
    LfoShape[LfoShape["Sine"] = 0] = "Sine";
    LfoShape[LfoShape["Triangle"] = 1] = "Triangle";
    LfoShape[LfoShape["SawUp"] = 2] = "SawUp";
    LfoShape[LfoShape["SawDown"] = 3] = "SawDown";
    LfoShape[LfoShape["Square"] = 4] = "Square";
})(LfoShape || (LfoShape = {}));
// WASM CONTRACT: `RatePPQNs` mirrors the engine's `modulation::RATES` (crates/engine/src/modulation.rs).
export class LfoModulatorBoxAdapter extends ModulatorBoxAdapter {
    constructor(context, box) {
        super(context, box);
        _LfoModulatorBoxAdapter_instances.add(this);
        this.namedParameter = __classPrivateFieldGet(this, _LfoModulatorBoxAdapter_instances, "m", _LfoModulatorBoxAdapter_wrapParameters).call(this, box);
        this.registerParameterTracks();
    }
}
_a = LfoModulatorBoxAdapter, _LfoModulatorBoxAdapter_instances = new WeakSet(), _LfoModulatorBoxAdapter_wrapParameters = function _LfoModulatorBoxAdapter_wrapParameters(box) {
    return {
        shape: this.parametric.createParameter(box.shape, ValueMapping.linearInteger(0, _a.ShapeStrings.length - 1), StringMapping.indices("", _a.ShapeStrings), "Shape"),
        rateSync: this.parametric.createParameter(box.rateSync, ValueMapping.linearInteger(0, _a.RateStrings.length - 1), StringMapping.indices("", _a.RateStrings), "Sync"),
        rateAbsolute: this.parametric.createParameter(box.rateAbsolute, ValueMapping.powerByCenter(_a.CenterAbsoluteRate, 0.0, _a.MaxAbsoluteRate), StringMapping.numeric({ unit: "Hz", fractionDigits: 2 }), "Free"),
        phase: this.parametric.createParameter(box.phase, ValueMapping.unipolar(), StringMapping.percent({ fractionDigits: 0 }), "Phase"),
        exponent: this.parametric.createParameter(box.exponent, ValueMapping.bipolar(), StringMapping.percent({ fractionDigits: 0 }), "Pow")
    };
};
LfoModulatorBoxAdapter.Rates = [
    [8, 1], [4, 1], [2, 1], [1, 1], [1, 2], [1, 4], [1, 6], [1, 8], [1, 12], [1, 16], [1, 24], [1, 32]
];
LfoModulatorBoxAdapter.MaxAbsoluteRate = 10.0;
LfoModulatorBoxAdapter.ExponentRange = 8.0;
LfoModulatorBoxAdapter.CenterAbsoluteRate = 1.0;
LfoModulatorBoxAdapter.RatePPQNs = [0, ..._a.Rates
        .map(([nominator, denominator]) => PPQN.fromSignature(nominator, denominator))];
LfoModulatorBoxAdapter.RateStrings = ["Off", ..._a.Rates
        .map(([nominator, denominator]) => denominator === 1
        ? (nominator === 1 ? "1 bar" : `${nominator} bars`)
        : `${nominator}/${denominator}`)];
LfoModulatorBoxAdapter.ShapeStrings = ["Sine", "Triangle", "Saw ↑", "Saw ↓", "Square"];
